import React, { useState, useEffect } from "react";

import { Row, Col, Input, Button, Alert, Container, Label } from "reactstrap";
import { apiReq } from "../../utils/utils";
import * as url from "../../utils/urls";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import QRCode from "react-qr-code";

import { Link } from "react-router-dom";

// import images
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-light.png";
import EEAA_LOGO from "../../assets/images/eeaa.png";
import Swal from "sweetalert2";

const Login = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [secret, setSecret] = useState(null);
  const [code, setCode] = useState("");
  const history = useHistory();
  // dispatch
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleVerify = (e) => {
    e.preventDefault();
    if (code === "") {
      Swal.fire({
        title: "Warning",
        text: "Please enter a valid code",
        icon: "warning",
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      setIsLoading(true);
      apiReq(
        url.VALIDATE_TOKEN,
        {
          token: code,
          secret: secret.secret.base32,
          user: secret.user,
        },
        "post",
        {}
      )
        .then((res) => {
          if (res.success) {
            localStorage.setItem("infoSalonsUser", JSON.stringify(res.data));
            localStorage.removeItem("infoSalonsSecret");
            setSecret(null);
            dispatch({ type: "USER_LOGIN", payload: res.data });
            history.push("/");
          } else {
            Swal.fire({
              title: "Warning",
              text: res.message,
              showConfirmButton: false,
              timer: 1500,
              icon: "warning",
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          Swal.fire({
            title: "Warning",
            text: err.message,
            icon: "warning",
            showConfirmButton: false,
            timer: 1500,
          });
          setIsLoading(false);
        });
    }
  };

  console.log("secret", secret);

  const onSubmit = (data) => {
    setIsLoading(true);
    apiReq(
      url.USER_LOGIN,
      {
        email: data.email,
        password: data.password,
      },
      "post",
      {}
    )
      .then((res) => {
        // console.log(res);
        if (res.success) {
          if (res.secret === null) {
            localStorage.setItem("infoSalonsUser", JSON.stringify(res.data));
            localStorage.removeItem("infoSalonsSecret");
            setSecret(null);
            dispatch({ type: "USER_LOGIN", payload: res.data });
            history.push("/dashboard");
          } else {
            const data = {
              user: res.data._id,
              secret: res.secret,
            };
            setSecret(data);
            localStorage.setItem("infoSalonsSecret", JSON.stringify(data));
          }
        } else {
          Swal.fire({
            title: "Oops!",
            text: res.message,
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }

        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        alert(err.apiStatus.statusMessage);
      });
    console.log("Login values", data);
  };

  useEffect(() => {
    document.body.classList.add("auth-body-bg");

    return () => {
      document.body.classList.remove("auth-body-bg");
    };
  }, []);
  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={8}>
              <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={5}>
                      <div>
                        <div className="text-center">
                          <div>
                            <Link to="/" className="">
                              <img
                                src={logodark}
                                alt=""
                                height="50"
                                className="auth-logo logo-dark mx-auto"
                              />
                              <img
                                src={logodark}
                                alt=""
                                height="50"
                                className="auth-logo logo-light mx-auto"
                              />
                            </Link>
                          </div>

                          <h4 className="font-size-18 mt-4">Welcome Back !</h4>
                          <p className="text-muted">
                            {secret !== null
                              ? "Please verify your account"
                              : "Sign in to continue to Info Salons."}
                          </p>
                        </div>

                        <div className="p-2 mt-5">
                          {secret !== null ? (
                            <form onSubmit={handleVerify}>
                              <div className="mb-4">
                                <div
                                  className="qr_code_img"
                                  style={{
                                    position: "relative",
                                    overflow: "hidden",
                                    borderRadius: "5px",
                                  }}
                                >
                                  <QRCode
                                    value={secret.secret.otpauth_url}
                                    size={130}
                                  />
                                </div>
                                <div className="mb-4 form-group">
                                  <label>Enter Code</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter code"
                                    value={code}
                                    onChange={(e) => {
                                      const re = /^[0-9\b]+$/;
                                      if (
                                        e.target.value === "" ||
                                        re.test(e.target.value)
                                      ) {
                                        setCode(e.target.value);
                                      }
                                    }}
                                  />
                                </div>
                                <div className="mt-4 text-center">
                                  {isLoading ? (
                                    <Button
                                      color="primary"
                                      className="w-md waves-effect waves-light"
                                      type="button"
                                      block
                                      style={{ width: "100%" }}
                                    >
                                      Loading...
                                    </Button>
                                  ) : (
                                    <Button
                                      color="primary"
                                      className="w-md waves-effect waves-light"
                                      type="submit"
                                      block
                                      style={{ width: "100%" }}
                                    >
                                      Submit
                                    </Button>
                                  )}
                                </div>
                              </div>
                            </form>
                          ) : (
                            <form
                              className="form-horizontal"
                              onSubmit={handleSubmit(onSubmit)}
                            >
                              {errors.email && (
                                <div
                                  className="alert alert-danger alert-dismissible mb-2"
                                  role="alert"
                                >
                                  {errors.email.message}
                                </div>
                              )}
                              {errors.password && (
                                <div
                                  className="alert alert-danger alert-dismissible mb-2"
                                  role="alert"
                                >
                                  {errors.password.message}
                                </div>
                              )}
                              <div className="mb-4 form-group">
                                <label>Email</label>
                                <input
                                  type="email"
                                  className="form-control form-control-lg input-lg"
                                  placeholder="Enter your work email"
                                  {...register("email", {
                                    required: "Email address is required.",
                                    pattern: {
                                      value:
                                        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                      message: "invalid email address",
                                    },
                                  })}
                                />
                              </div>

                              <div
                                className="mb-4 form-group"
                                style={{ position: "relative" }}
                              >
                                <label>Password</label>
                                <input
                                  type={isShow ? "text" : "password"}
                                  className="form-control form-control-lg input-lg"
                                  placeholder="Enter password"
                                  {...register("password", {
                                    required: "You must specify a password",
                                    minLength: {
                                      value: 8,
                                      message:
                                        "Password must have at least 8 characters",
                                    },
                                    pattern: {
                                      value:
                                        /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}/,
                                      message:
                                        "Please use atleast 1 special character, and 1 capital letter in the password.",
                                    },
                                  })}
                                />
                                <div
                                  className="eye_button"
                                  onClick={() => setIsShow(!isShow)}
                                >
                                  {isShow ? (
                                    <i className="mdi mdi-eye"></i>
                                  ) : (
                                    <i className="mdi mdi-eye-off"></i>
                                  )}
                                </div>
                              </div>
                              <div className="mt-4 d-flex justify-content-end">
                                <Link
                                  to="/forgot-password"
                                  className="text-link"
                                >
                                  <i className="mdi mdi-lock me-1"></i> Forgot
                                  your password?
                                </Link>
                              </div>

                              <div className="mt-4 text-center">
                                {isLoading ? (
                                  <Button
                                    color="primary"
                                    className="w-md waves-effect waves-light"
                                    type="button"
                                    block
                                    style={{ width: "100%" }}
                                  >
                                    Loading...
                                  </Button>
                                ) : (
                                  <Button
                                    color="primary"
                                    className="w-md waves-effect waves-light"
                                    type="submit"
                                    block
                                    style={{ width: "100%" }}
                                  >
                                    Log In
                                  </Button>
                                )}
                              </div>

                              <div className="d-flex justify-content-center mt-3">
                                <Link to="/login-sso" className="text-link">
                                  Log In with Single Sign-On (SSO)
                                </Link>
                              </div>
                            </form>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div className="authentication-bg">
                <div
                  className="login_options d-flex align-items-center"
                  style={{ height: "100%" }}
                >
                  <div className="options_inner">
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_lg">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                    </div>
                    <p className="text-center mb-0">Recognized as</p>
                    <p className="text-center">
                      EEAA Best Innovation in Event Tech Winner
                    </p>
                    <div className="login_option_logo_wrapper">
                      <div className="login_option_logo d-flex justify-content-center align-items-center">
                        <img src={EEAA_LOGO} alt={"EEAA_LOGO"} width="200" />
                      </div>
                      <div className="sap_line"></div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_lg">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                    </div>
                    <p className="text-center" style={{ fontSize: 18 }}>
                      Recognized by customers across the world as a leader in
                      tech event, online & mobile solutions.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;
